import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const [cookies] = useCookies(['token']);
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const validateToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      console.log(decoded);
      console.log(decoded.exp * 1000 > Date.now());
      return decoded.exp * 1000 > Date.now();
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const checkAuth = () => {
      if (cookies.token && validateToken(cookies.token)) {
        setIsAuthenticated(true);
        return true;
      }
      setIsAuthenticated(false);
      return false;
    };

    checkAuth();
  }, [cookies.token]);

  const checkAndRedirect = (path = '/') => {
    if (validateToken(cookies.token)) {
      navigate(path);
      return true;
    }
    return false;
  };

  return { isAuthenticated, checkAndRedirect };
};